import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDragBackgroundCursor = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 104 104",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M60.0116 1.03494L44.379 1.00009C35.8408 0.979959 27.6444 4.3539 21.5919 10.3785L10.5133 21.4073C4.46395 27.4297 1.05343 35.6121 1.03495 44.1501L1.00009 59.7827C0.979958 68.3209 4.3539 76.5173 10.3785 82.5697L21.4073 93.6483C27.4316 99.6991 35.6124 103.11 44.1506 103.13L59.7832 103.165C68.3214 103.185 76.5178 99.811 82.5702 93.7864L93.6488 82.7576C99.6996 76.7333 103.11 68.5526 103.13 60.0144L103.165 44.3818C103.185 35.8436 99.8115 27.6472 93.7869 21.5947L82.7582 10.5162C76.7338 4.46536 68.5531 1.0546 60.0149 1.03447L60.0116 1.03494Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgDragBackgroundCursor);
export default ForwardRef;
